import { Field, Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import * as Yup from 'yup'

const inputBase =
  'block w-full px-3 py-2 mt-2 border bg-white rounded-md text-sm focus:ring-2 focus:ring-opacity-30 focus:outline-none transition-colors duration-150'
const inputNormal =
  'text-gray-700 border-gray-300 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-[#006F53] focus:ring-[#006F53]'
const inputError =
  'border-red-400 text-red-900 placeholder-red-400 focus:ring-red-400 focus:border-red-400 dark:bg-gray-700 dark:text-red-500 dark:border-red-500'

export default function LoginForm({ loginError, handleSubmit }) {
  const validationSchema = Yup.object().shape({
    email: Yup.string().email('Correu invàlid').required('Introduïu un correu'),
    password: Yup.string().required('Introduïu una contrasenya')
  })

  // Test
  return (
    <Formik
      initialValues={{ email: '', password: '' }}
      validationSchema={validationSchema}
      onSubmit={(values) => handleSubmit(values)}
    >
      {({ errors, touched }) => (
        <Form className="space-y-5">
          {/* Correu */}
          <div>
            <label
              htmlFor="email"
              className={`block text-sm font-medium ${touched.email && errors.email ? 'text-red-600' : 'text-gray-700 dark:text-gray-200'}`}
            >
              Correu electrònic
            </label>

            <Field
              id="email"
              name="email"
              type="email"
              className={`${inputBase} ${touched.email && errors.email ? inputError : inputNormal}`}
              autoComplete="new-password"
              placeholder="exemple@exemple.com"
            />

            <div
              className={`mt-1 text-xs text-red-600 ${touched.email && errors.email ? 'visible' : 'invisible'}`}
            >
              {errors.email || ' '}
            </div>
          </div>

          {/* Contrasenya */}
          <div>
            <div className="flex items-center justify-between mb-1">
              <label
                htmlFor="password"
                className={`block text-sm font-medium ${touched.password && errors.password ? 'text-red-600' : 'text-gray-700 dark:text-gray-200'}`}
              >
                Contrasenya
              </label>

              <a
                href="#"
                className="text-xs text-[#006F53] hover:text-[#005540] hover:underline transition-colors"
              >
                Ha oblidat la contrasenya?
              </a>
            </div>

            <Field
              id="password"
              name="password"
              type="password"
              className={`${inputBase} ${touched.password && errors.password ? inputError : inputNormal}`}
              autoComplete="new-password"
            />

            <div
              className={`mt-1 text-xs text-red-600 ${touched.password && errors.password ? 'visible' : 'invisible'}`}
            >
              {errors.password || ' '}
            </div>
          </div>

          {/* Botó submit */}
          <button
            type="submit"
            className="w-full py-2.5 px-5 text-sm font-semibold text-white bg-[#006F53] border border-[#006F53] rounded-md transition-colors duration-200 hover:bg-[#005540] hover:border-[#005540] focus:outline-none focus:ring-2 focus:ring-[#006F53] focus:ring-opacity-40"
          >
            Iniciar sessió
          </button>

          {/* Missatge d'error d'autenticació */}
          <div
            className={`flex items-center gap-2 px-3 py-2 text-sm text-red-700 bg-red-50 border border-red-300 rounded-md ${loginError ? 'visible' : 'invisible'}`}
            role="alert"
          >
            <span className="font-semibold">Error:</span>
            <span>{loginError}</span>
          </div>
        </Form>
      )}
    </Formik>
  )
}

LoginForm.propTypes = {
  loginError: PropTypes.any,
  handleSubmit: PropTypes.func
}
